// extracted by mini-css-extract-plugin
export default {"icon":"ShopperGroupIncentiveIcon_icon__CeucT"};